import styled from "styled-components";
import { ActionMenuSelectMultipleAvailable } from "./action-menu-select-multiple-available";

// tslint:disable-next-line
export const ActionMenuSelectMultipleAssigned = styled(
  ActionMenuSelectMultipleAvailable
)`
  margin-top: 26px;
`;
